import { Button } from "@tfg/ui"

import { queryClient } from "~/backend/queryClient"
import { useDeactivateUsersByOrganizationId } from "~/gen/api"

type ToggleOrganizationUsersStatusButtonProps = {
  organizationId: string
}

export const ToggleOrganizationUsersStatusButton = ({
  organizationId,
}: ToggleOrganizationUsersStatusButtonProps) => {
  const { mutateAsync: deactivateUsersByOrganizationId } =
    useDeactivateUsersByOrganizationId({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ["organizations", organizationId],
          })
        },
      },
    })

  const handleToggleOrganizationUsersStatus = async () => {
    await deactivateUsersByOrganizationId({ data: { organizationId } })
  }

  return (
    <Button
      variant="primary"
      fullWidth={false}
      data-organization-id={organizationId}
      onClick={handleToggleOrganizationUsersStatus}
    >
      Deactivate organization users
    </Button>
  )
}
